// Copyright (c) 2020 Deere & Company

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const EditableField = props => props.isEditable ?
    props.children : (
        <span className={props.className}>
            {props.link ? ( <Link to={props.link}>{props.value}</Link> ) : props.value}
        </span>
    );

EditableField.displayName = 'EditableField';
EditableField.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    link: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] )
};

export default EditableField;
